import { render, staticRenderFns } from "./undertakesTask.vue?vue&type=template&id=40a70444"
import script from "./undertakesTask.vue?vue&type=script&lang=js"
export * from "./undertakesTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports